var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgErrorPageIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "54px",
    viewBox: "0 0 48 54",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_assignment_late") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "remove-account---DONE",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "error-page",
    transform: "translate(-136.000000, -182.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_assignment_late",
    transform: "translate(128.000000, 180.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Bounds",
    points: "0 0 64 0 64 64 0 64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6666667,8 L39.52,8 C38.4,4.90666667 35.4666667,2.66666667 32,2.66666667 C28.5333333,2.66666667 25.6,4.90666667 24.48,8 L13.3333333,8 C10.4,8 8,10.4 8,13.3333333 L8,50.6666667 C8,53.6 10.4,56 13.3333333,56 L50.6666667,56 C53.6,56 56,53.6 56,50.6666667 L56,13.3333333 C56,10.4 53.6,8 50.6666667,8 L50.6666667,8 Z M34.6666667,48 L29.3333333,48 L29.3333333,42.6666667 L34.6666667,42.6666667 L34.6666667,48 L34.6666667,48 Z M34.6666667,37.3333333 L29.3333333,37.3333333 L29.3333333,21.3333333 L34.6666667,21.3333333 L34.6666667,37.3333333 L34.6666667,37.3333333 Z M32,13.3333333 C30.5333333,13.3333333 29.3333333,12.1333333 29.3333333,10.6666667 C29.3333333,9.2 30.5333333,8 32,8 C33.4666667,8 34.6666667,9.2 34.6666667,10.6666667 C34.6666667,12.1333333 33.4666667,13.3333333 32,13.3333333 L32,13.3333333 Z",
    id: "Shape",
    fillOpacity: 0.54,
    fill: "#000000"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorPageIcon);
export default __webpack_public_path__ + "static/media/error-page-icon.46a0d90bd978d3ae420a0ebe2eb1fa23.svg";
export { ForwardRef as ReactComponent };